import { Observable } from 'rxjs';
import { NewOrderAddress } from 'src/app/shared/models/address/address';
import { Warehouse } from 'src/app/shared/models/warehouse';

export abstract class IOrderProcessService {
  public abstract getWarehouses(): Observable<Warehouse[]>;
  public abstract getAddresses(accountKey: string): Observable<NewOrderAddress[]>;
}
